/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Shop_Group_RelatedInputs */

const vi_shop_group_related = /** @type {(inputs: Shop_Group_RelatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Khách thường mua kèm (chọn nhóm khác, tối đa ${i?.max})`)
};

/**

* @param {Shop_Group_RelatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_related = /** @type {((inputs: Shop_Group_RelatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_RelatedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_related(inputs)
});